import React, {useState} from 'react';
import {Dropdown, DropdownToggle, DropdownMenu} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {getLoggedInUser} from '../../../helpers/fakebackend_helper';

const ProfileMenu = ({t}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const authUser = getLoggedInUser();

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <Dropdown isOpen={menuOpen} toggle={toggleMenu} className="d-inline-block">
      <DropdownToggle className="btn header-item waves-effect" tag="button">
        <span className="d-inline-block ml-2 mr-1">
          {authUser.user.firstname} {authUser.user.lastname}
        </span>
        <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
      </DropdownToggle>

      <DropdownMenu end>
        <Link to="/logout" className="dropdown-item">
          <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger" />
          <span>{t('Logout')}</span>
        </Link>
      </DropdownMenu>
    </Dropdown>
  );
};

const mapStateToProps = (state) => ({
  error: state.Profile.error,
  success: state.Profile.success,
});

export default connect(mapStateToProps, {})(withTranslation()(ProfileMenu));
